import { navigate } from 'gatsby';
import { useEffect } from 'react';
import { useStripe } from '@stripe/react-stripe-js';
import useConfig from 'common/providers/configProvider/use-config';
import logger from '../../common/utils/logger';
import { useWallet } from '../providers/walletProvider';
import { useOAT } from '../../common/providers/oatProvider';
import { socketMessages } from '../../common/utils/socket';

const useWalletPayment = () => {
  const stripe = useStripe();
  const { paymentRequest } = useWallet();
  const {
    data: { cardPaymentAmount, clientSecret },
    socket,
  } = useOAT();
  const { getPagePath, brand } = useConfig();
  const confirmCardPayment = stripe?.confirmCardPayment;

  useEffect(() => {
    if (paymentRequest) {
      paymentRequest.update({
        total: {
          label: brand,
          amount: cardPaymentAmount,
          pending: false,
        },
      });
    }
  }, [paymentRequest, cardPaymentAmount, brand]);

  useEffect(() => {
    if (paymentRequest && clientSecret && confirmCardPayment) {
      paymentRequest.on('paymentmethod', async (ev) => {
        socket.emit(socketMessages.paymentSubmitted);

        // See: https://stripe.com/docs/stripe-js/elements/payment-request-button?html-or-react=react&platform=react-testing-apple-pay#react-complete-payment
        const { error: confirmError } = await confirmCardPayment(
          clientSecret,
          { payment_method: ev.paymentMethod.id },
          { handleActions: false }
        );

        if (confirmError) {
          ev.complete('fail');
          // should redirect Gpay & Apple users to payment-failure screen
          navigate(getPagePath('payment-error'));
        } else {
          // Report to the browser that the confirmation was successful, prompting
          // it to close the browser payment method collection interface.
          logger.info({ msg: 'Payment Confirmation succeeded' });
          ev.complete('success');
          // Let Stripe.js handle the rest of the payment flow.
          const { error, paymentIntent } = await confirmCardPayment(clientSecret);

          if (error) {
            navigate(getPagePath('payment-error'));
          } else {
            logger.info({ msg: 'payment result successful!', paymentIntent });
          }
        }
      });
    }
    // eslint-disable-next-line no-autofix/react-hooks/exhaustive-deps
  }, [paymentRequest, clientSecret, confirmCardPayment, socket]);
};

export default useWalletPayment;
